import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import { getBalanceAndPin } from "../../features/balance-and-pin/balanceAndPinSlice";
import { formattedBalance } from "../../features/balance-and-pin/utils";
import Spinner from "../../components/Spinner";
import {
  MainContainer,
  IntroSection,
  BalanceSection,
  Footer,
  PinModalOverlay
} from "../priceless-26-mb/styles";

import pricelessLogo from "./images/priceless-logo.svg";
import digiseqLogo from "../hsbc-26/images/digiseq-logo.png";
import muchBetterLogo from "../sail-gp-25/img/muchbetter-logo.svg";

const Priceless26London = () => {
  const [searchParams] = useSearchParams();
  const serialNumber = searchParams.get("serialNumber");
  const provider = searchParams.get("provider");

  const [isPinOpen, setIsPinOpen] = useState(false);

  const dispatch = useDispatch();
  const { balanceAndPin, isLoading } = useSelector(
    (state) => state.balanceAndPin
  );

  useEffect(() => {
    if (!balanceAndPin && serialNumber) {
      dispatch(
        getBalanceAndPin({
          serial: serialNumber,
          query: `?provider=${provider || "much_better"}`
        })
      );
    }
  }, [balanceAndPin, serialNumber, dispatch, provider]);

  if (isLoading) return <Spinner />;

  return (
    <MainContainer>
      <IntroSection>
        <div className="intro-logo">
          <img src={pricelessLogo} alt="Priceless" />
        </div>
        <div className="intro-text">
          <h1>Welcome to your Priceless Experience!</h1>
          <div className="intro-body">
            <p>On behalf of Mastercard, we extend our heartfelt greetings.</p>
            <p>
              Throughout the experience, we hope you make unforgettable
              memories. Whether you&apos;re soaking in the electric atmosphere
              of the McLaren Technology Centre or exploring the rich culture
              and landmarks of London, may this journey be filled with
              excitement, and cherished memories.
            </p>
            <div className="help-contact">
              <p>Help contact</p>
              <a href="mailto:mcpricelessexperiencesteam@octagon.com">
                Mastercard Priceless Experience Team
              </a>
            </div>
          </div>
        </div>
      </IntroSection>

      <BalanceSection>
        <div className="balance-info">
          <p className="balance-label">My Balance</p>
          <p className="balance-value">
            {formattedBalance(
              balanceAndPin?.balanceDetails?.availableBalance,
              balanceAndPin?.balanceDetails?.currency
            )}
          </p>
        </div>
        <button className="view-pin-button" onClick={() => setIsPinOpen(true)}>
          View PIN
        </button>
      </BalanceSection>

      <Footer>
        <div className="footer-block">
          <p className="footer-label">Powered by</p>
          <img
            src={digiseqLogo}
            alt="Digiseq"
            onClick={() =>
              window.open("https://www.digiseq.co.uk", "_blank", "noopener")
            }
          />
        </div>
        <div className="footer-block">
          <p className="footer-label">Payment services provided by</p>
          <img
            className="much-better-logo"
            src={muchBetterLogo}
            alt="MuchBetter"
            onClick={() => window.open("https://muchbetter.com/", "_blank")}
          />
        </div>
      </Footer>

      {isPinOpen && (
        <PinModalOverlay onClick={() => setIsPinOpen(false)}>
          <div className="pin-modal" onClick={(e) => e.stopPropagation()}>
            <button className="pin-close" onClick={() => setIsPinOpen(false)}>
              ×
            </button>
            <p className="pin-label">Your PIN</p>
            <p className="pin-value">{balanceAndPin?.pinDetails?.pin || "N/A"}</p>
          </div>
        </PinModalOverlay>
      )}
    </MainContainer>
  );
};

export default Priceless26London;
